import { Tabs } from "antd";
import { TabContent } from "./TabContent";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { useSearchParams } from "../../../../hook/use-search-params";

export const ConfigPermission = () => {
  const history = useHistory();
  const { searchParams } = useSearchParams();
  const tabId = searchParams.get("tab") || "1";
  const menuId = searchParams.get("menuId") || "54";

  const tabItems = [
    {
      label: "Quản lý nhóm",
      key: "1",
      children: <TabContent />,
    },
    {
      label: "Phân quyền sử dụng",
      key: "2",
      children: <TabContent />,
    },
  ];

  return (
    <div>
      <Tabs
        defaultActiveKey={tabId}
        items={tabItems}
        type="card"
        size="large"
        onTabClick={(e: any) => history.push({ pathname: Routes.ConfigProcedure.path, search: `configId=14&tab=${e}&menuId=${menuId}` })}
      />
    </div>
  );
};
